import { Navigate } from 'react-router-dom'
import { menuUrls } from '../../constants/menu.constants'

// Permission Router Guard
const PermissionRouterGuard = ({ isAllowed = false, redirectPath = menuUrls.accessDenied, children = <></> }) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />
  }

  return children
}

export default PermissionRouterGuard
